import {config} from "../../config";
import {store} from "../../store";
import {GameActionCreators} from "../../store/reducers/game/action-creators";
import GameService from "../../api/GameService";

export const WsService = {
    wsConnection: null,
    allowPlayBot: true,
    forcePlayBot: false,
    inQueue: false,

    messageToSend: [],
    receivedMessage: [],
    messageLoop: false,

    clearMessages: function () {
        WsService.messageToSend = [];
        WsService.receivedMessage = [];
        WsService.messageLoop = false;
    },

    sendingMessageLoop: async function (runLoop) {
        WsService.messageLoop = runLoop;

        while (WsService.messageLoop) {

            if (WsService.messageToSend.length === 0) {
                await new Promise(r => setTimeout(r, 100));
                continue;
            }

            // @ts-ignore
            if (WsService.wsConnection && WsService?.wsConnection?.readyState === WebSocket.OPEN) {
                const message = WsService.messageToSend.shift();
                // @ts-ignore
                WsService.wsConnection.send(message);
            }

            await new Promise(r => setTimeout(r, 200));
        }
    },

    start: async function (clearState = false) {

        // @ts-ignore
        if (WsService.wsConnection && WsService?.wsConnection?.readyState !== WebSocket.CLOSED) {
            WsService.wsConnection = null;
        }

        console.log('WebSocket start');
        // @ts-ignore
        WsService.wsConnection = new WebSocket(config.wsServerUrl);

        // @ts-ignore
        WsService.wsConnection.onmessage = function (income) {
            console.log('WebSocket onmessage');

            const message = JSON.parse(income.data);

            if (WsService.receivedMessage[message.hash] !== undefined) {
                return;
            }
            // @ts-ignore
            WsService.receivedMessage[message.hash] = 1;

            WsService.processMessage(message.data);

            const state = store.getState();
            const data = {
                'action': 'confirm',
                'version': config.VERSION,
                'data': {
                    'user_id': state.auth.user.id,
                    'hash': message.hash
                }
            };
            // @ts-ignore
            WsService.messageToSend.push(JSON.stringify(data));
        };

        // @ts-ignore
        WsService.wsConnection.onopen = function (e) {
            const state = store.getState();
            const data = {
                'action': 'register',
                'version': config.VERSION,
                'clear_state': clearState,
                'data': {
                    'user_id': state.auth.user.id,
                }
            };
            console.log('WebSocket open');
            // @ts-ignore
            WsService.messageToSend.push(JSON.stringify(data));
        };

        // @ts-ignore
        WsService.wsConnection.onclose = async function (event) {
            console.log("WebSocket closed:", event.code, event.reason);
            // console.log('WebSocket connection closed. Reconnecting in', 2000, 'seconds');

            await new Promise(r => setTimeout(r, 2000));
            WsService.start();
        };

        // @ts-ignore
        WsService.wsConnection.onerror = function (error) {
            console.log('WebSocket error:', error);
            // @ts-ignore
            //  WsService.wsConnection.close(); // Close WebSocket connection to trigger onclose and attempt reconnect
        };

        return true;
    },
    confirmStartGame: async function (players) {
        let loop = true
        while (loop) {
            if (loop) {
                let response = await GameService.confirmStartGame(players);

                if (response) {
                    let data = response.data;

                    if (data.result === 'opponent_leave' || data.result === 'start_game') {
                        loop = false;
                        if (data.result === 'opponent_leave') {
                            const res = await GameService.queue();
                            if (res?.data) {
                                WsService.forcePlayBot = true;
                            }
                        }
                    }
                } else {
                    loop = false;
                }
            }
            await new Promise(r => setTimeout(r, 5000));
        }
    },
    enterQueue: function () {
        GameService.queue();
    },
    processMessage: function (data) {


        if (data?.type === 'confirm_start_game') {
            if (WsService.inQueue) {
                WsService.allowPlayBot = false;
                WsService.confirmStartGame(data.players);
            }

            return;
        }

        if (data?.type === 'cancel_warning') {
            GameService.cancelWarning();

            return;
        }

        store.dispatch(GameActionCreators.setGamePvPData(data));

    }

}